import { Component, OnInit, Inject, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AngularFireDatabase } from 'angularfire2/database-deprecated';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ChooseCompanyService } from '../../../../core/services/choose-company.service';
import { FuseUtils } from '../../../../core/fuseUtils';
import * as firebase from 'firebase';
import { ImageToDataUrlService } from '../../../../core/services/image-to-data-url/image-to-data-url.service';
import { AngularFirestore } from 'angularfire2/firestore';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit, OnDestroy {

  form: FormGroup;
  formErrors: any;
  companyIndex = 0;
  company: any;
  temp: any;
  templates = [];
  bannerLinks: any;
  deleteitem = false;
  savedButton = false;
  bannerImage: any;
  subs = new Subscription();
  brandId: any;

  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    private afm: AngularFireDatabase,
    private formBuilder: FormBuilder,
    private chooseCompany: ChooseCompanyService,
    private cd: ChangeDetectorRef,
    private afs: AngularFirestore,
    private imageResize: ImageToDataUrlService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.formErrors = {
      company: {},
      main: {},
      password: {},
      currentPassword: {},
      issue: {},
      city: {},
      state: {},
      postalCode: {}
    };
    chooseCompany.activeCompanyIndex.subscribe(index => this.companyIndex = index);
    chooseCompany.getCompany().subscribe(company => {
      this.company = company;
      this.templates = company.templates || [];


    });
    this.subs.add(this.chooseCompany.getcompanyId().subscribe(data => {
      if (data.id) {
        this.brandId = data.id
      }

    }))



  }

  close() {
    this.dialogRef.close()
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      company: [
        {
          value: 'Google',
          disabled: true
        }, Validators.required
      ],
      main: ["", Validators.required]
    });

    this.subs.add(this.form.valueChanges.subscribe(() => {
      this.onFormValuesChanged();
    }));
    this.afs.collection('brands').doc(this.brandId).ref.get().then((data => {
      if (data.data().bannerLink) {
        this.bannerLinks = data.data().bannerLink;
      }
      if (data.data().bannerImage) {
        this.bannerImage = data.data().bannerImage;
      }
    }))


  }

  onFormValuesChanged() {
    for (const field in this.formErrors) {
      if (!this.formErrors.hasOwnProperty(field)) {
        continue;
      }

      // Clear previous errors
      this.formErrors[field] = {};

      // Get the control
      const control = this.form.get(field);

      if (control && control.dirty && !control.valid) {
        this.formErrors[field] = control.errors;
      }
    }
  }


  send() {

    let main = this.form.get('main').value;
    this.bannerLinks = main;
    this.afs.collection('brands').doc(this.brandId).update({ bannerLink: main });

    this.deleteitem = false;
    this.savedButton = true;
  }


  delete() {
    this.deleteitem = true;
    this.afs.collection('brands').doc(this.brandId).update({ bannerLink: firebase.firestore.FieldValue.delete() });

  }
  ngOnDestroy() {
    this.subs.unsubscribe();
  }


}
